import script from "./properties-form.vue?vue&type=script&lang=ts&setup=true"
export * from "./properties-form.vue?vue&type=script&lang=ts&setup=true"

import "./properties-form.vue?vue&type=style&index=0&id=6305b9b1&lang=scss&scoped=true"

import exportComponent from "D:\\web\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6305b9b1"]])

export default __exports__